import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

export const getTerminosPaymentTerms = async () => {
    const respuesta = PrivateInterceptor('Global/Terminos/PaymentTerms', 'GET')
    return respuesta
};

export const getTerminosIncoterms = async () => {
    const respuesta = PrivateInterceptor('Global/Terminos/Incoterms', 'GET')
    return respuesta
};

